export const PATCH_SEARCH = 'PATCH_SEARCH'
export const PATH_SEARCH_HISTORY = 'PATH_SEARCH_HISTORY'

export const FETCH_SUGGESTION_REQ = 'FETCH_SUGGESTION_REQ'
export const FETCH_SUGGESTION_SUCCESS = 'FETCH_SUGGESTION_SUCCESS'
export const FETCH_SUGGESTION_FAIL = 'FETCH_SUGGESTION_FAIL'

export const FETCH_RESULT_REQ = 'FETCH_RESULT_REQ'
export const FETCH_RESULT_SUCCESS = 'FETCH_RESULT_SUCCESS'
export const FETCH_RESULT_FAIL = 'FETCH_RESULT_FAIL'